import React, { useEffect } from 'react';
import { orderNavigationSlice } from '../../../../store/order/orderNavigation/orderNavigationSlice';
import { loadEscrowBalancesAsync } from '../../../../store/order/escrow/escrowBalancesHeaderSlice';
import { SpaOrderEscrowLayout } from './SpaOrderEscrowLayout';
import { SpaCreateEditTransactionsForm } from '../../../../components/order/escrow/escrowCreateEdit/spa/SpaCreateEditTransactionsForm';
import { useSelectCurrentOrder } from '../../../../selectors/order/selectCurrentOrder';
import { getEscrowFileAndVoidUsersAction } from '../../../../store/order/escrow/getEscrowFileAndVoidUsersAction';
import { useParams } from 'react-router-dom';
import { UUID } from '../../../../types/shared/UUID';
import { useGetDetailedEscrowDataQuery } from 'API/order/escrow/EscrowBaseAPI';
import { useAppDispatch } from '../../../../store/store';

export const SpaOrderEscrowCreateEditContainer: React.FC = () => {
  const { orderId } = useParams<{ orderId: UUID }>();
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(orderNavigationSlice.actions.setup({ tab: 'Escrow' }));
    dispatch(loadEscrowBalancesAsync({ orderId }));
  }, [dispatch, orderId]);

  const { data: escrowData, refetch } = useGetDetailedEscrowDataQuery(orderId);
  const { data: order } = useSelectCurrentOrder();

  const onTransactionUpdate = async () => {
    dispatch(loadEscrowBalancesAsync({ orderId }));
    const { data } = await refetch();
    if (data) {
      dispatch(getEscrowFileAndVoidUsersAction(orderId, data));
    }
  };

  return (
    <SpaOrderEscrowLayout orderId={orderId}>
      <SpaCreateEditTransactionsForm
        escrowData={escrowData}
        orderId={orderId}
        order={order}
        onTransactionUpdate={onTransactionUpdate}
      />
    </SpaOrderEscrowLayout>
  );
};
